import { EnhancedJobForm } from '@/components/jobs/EnhancedJobForm';

export default function NewJobPage() {
  return (
    <div className="container mx-auto p-4 sm:p-6 max-w-6xl">
      <div className="mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold mb-2">Create New Job</h1>
        <p className="text-sm sm:text-base text-muted-foreground">
          Create a procurement job with specifications and delivery details using our enhanced workflow.
        </p>
      </div>

      <EnhancedJobForm />
    </div>
  );
}